import { render, staticRenderFns } from "./VideoOnScroll.vue?vue&type=template&id=527ef2e8"
import script from "./VideoOnScroll.vue?vue&type=script&lang=js"
export * from "./VideoOnScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports